import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ApiService } from '../../../app/service/api_service';
import { } from 'googlemaps';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { Router } from '@angular/router';
import { SubscribeOnObservable } from 'rxjs/internal-compatibility';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs'; 
import karmaConf from 'karma.conf';

@Component({
    selector: 'app-routemaster',
    template: require('./routemaster.component.html'),
    styles: [],
    viewProviders: [ApiService]
})
export class RouteMasterComponent implements OnInit {
    private columnDefs;
    private rowData;
    private rowHeight;
    api: any;
    busy: Subscription;
    columnApi: any;
    defaultColDefine;
    private gridColumnApi;
    routeaddData: any;
    routeData: any = []
    submitted = false;
    formattedAddress = "";
    formattedAddressvia1 = "";
    formattedAddressvia2 = "";
    formattedAddressvia3 = "";
    activeBtncol: boolean = true;
    latitude: number;
    longitude: number;
    zoom: number;
    actual_KM: number;
    address: string;
    private geoCoder;
    token:any;
    kilometer: any;
    @Input() adressType: string;
    @Output() setAddress: EventEmitter<any> = new EventEmitter();
    @ViewChild('addresstext') addresstext: any;
    @ViewChild('close') public modal: ElementRef;

    autocompleteInput: string;
    queryWait: boolean;
    route_name: string;

    @ViewChild("placesRef") placesRef: GooglePlaceDirective;
    @ViewChild("placesRefvia1") placesRefvia1: GooglePlaceDirective;
    @ViewChild("placesRefvia2") placesRefvia2: GooglePlaceDirective;
    @ViewChild("placesRefvia3") placesRefvia3: GooglePlaceDirective;
    options = {
        componentRestrictions: {
            country: ['IN']
        }
    }

    optionsvia1 = {
        componentRestrictions: {
            country: ['IN']
        }
    }

    static parameters = [ApiService, Router, ToastrService];
    constructor(private apiService: ApiService, private router: Router, private toast: ToastrService) {
        let parent = this;
        this.columnDefs = [
            { headerName: 'Employee Name', field: 'EmployeeName' },
            { headerName: 'Head Qtr', field: 'HeadQuarter' },
            // { headerName: 'Division', field: '' },
            { headerName: 'No of Route', field: 'noOfRoute' },
            {
                headerName: 'Action', field: 'action', width: 80, pinned: 'right', cellRenderer: function (params) {
                    var eDiv = document.createElement('div');
                    eDiv.innerHTML = `<div class="grid_actions"> 
                        <span class="grid_actions_item viewBtn">
                            <i class="icon-view"></i>
                        </span>
                        <span class="addBtn grid_actions_item" data-target="#squarespaceModal" data-toggle="modal">
                            <i class="icon-add"></i>
                        </span>
                    </div>`;
                    var addButton = eDiv.querySelectorAll('.addBtn')[0];
                    var viewButton = eDiv.querySelectorAll('.viewBtn')[0];
                    viewButton.addEventListener('click', function () {
                        parent.router.navigate(['/routelist'], { queryParams: { id: params.data.EmpId } });
                    })
                    addButton.addEventListener('click', function () {                        
                        parent.ResetRouteForm();
                        parent.routeaddData = params.data;
                        //console.log(parent.routeaddData);
                    })
                    return eDiv;
                }
            }
        ];
        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };

        // this.route_form.controls['DAType'].setValue(this.defaultSelect);
    }

    public sourcedisabletexbox(sourcetextvalue: any) {
        //  console.log(vai1textvalue.trim().length);
        if (sourcetextvalue.trim().length <= 0) {
            this.Routeformgroup.controls['via1'].disable();
            this.Routeformgroup.controls['via2'].disable();
            this.Routeformgroup.controls['via3'].disable();
            this.Routeformgroup.controls['via1'].setValue('');
            this.Routeformgroup.controls['via2'].setValue('');
            this.Routeformgroup.controls['via3'].setValue('');
            this.CalculateRouteKM(0);
        }
    }

    public vai1disabletexbox(vai1: any) {
        if (vai1.trim().length <= 0) {
            this.Routeformgroup.controls['via2'].disable();
            this.Routeformgroup.controls['via3'].disable();
            this.Routeformgroup.controls['via2'].setValue('');
            this.Routeformgroup.controls['via3'].setValue('');
            this.route_nm();
            this.CalculateRouteKM(0);
        }
    }

    public vai2disabletexbox(vai2: any) {
        if (vai2.trim().length <= 0) {
            this.Routeformgroup.controls['via3'].disable();
            this.Routeformgroup.controls['via3'].setValue('');
            this.route_nm();
            this.CalculateRouteKM(1);
        }
    }

    public vai3disabletexbox(vai3: any) {
        if (vai3.trim().length <= 0) {
            this.route_nm();
            this.CalculateRouteKM(2);
        }
    }

    public handleAddressChange(address: any) {
        this.formattedAddress = this.placesRef.place.name;
        this.route_nm();
        if (this.formattedAddress.trim().length > 0) {
            this.Routeformgroup.controls['via1'].enable();
        }
    }

    public handleAddressChangevia1(address: any) {
        this.formattedAddressvia1 = this.placesRefvia1.place.name;
        this.route_nm();
        if (this.formattedAddressvia1.trim().length > 0) {
            this.Routeformgroup.controls['via2'].enable();
        }
        this.CalculateRouteKM(1);
    }

    public handleAddressChangevia2(address: any) {
        this.formattedAddressvia2 = this.placesRefvia2.place.name;
        this.route_nm();
        if (this.formattedAddressvia2.trim().length > 0) {
            this.Routeformgroup.controls['via3'].enable();
        }
        this.CalculateRouteKM(2);
    }
    
    public handleAddressChangevia3(address: any) {
        this.formattedAddressvia3 = this.placesRefvia3.place.name;
        this.route_nm();
        this.CalculateRouteKM(3);
    }

    CalculateRouteKM(id){
        var KM = 0;
        if(id > 0){
            var lat1 = this.f_chkString(this.placesRef.place? this.placesRef.place.name: "").length > 0? this.placesRef.place.geometry.location.lat(): 0;
            var lng1 = this.f_chkString(this.placesRef.place? this.placesRef.place.name: "").length > 0? this.placesRef.place.geometry.location.lng(): 0;
            var lat2 = this.f_chkString(this.placesRefvia1.place? this.placesRefvia1.place.name: "").length > 0? this.placesRefvia1.place.geometry.location.lat(): 0;
            var lng2 = this.f_chkString(this.placesRefvia1.place? this.placesRefvia1.place.name: "").length > 0? this.placesRefvia1.place.geometry.location.lng(): 0;
            if(lat1 > 0 && lng1 > 0 && lat2 > 0 && lng2 > 0){
                KM = this.CalculateDistance(lat1, lng1,lat2, lng2, "K");
            }
        }
        if(id > 1){
            var lat1 = this.f_chkString(this.placesRefvia1.place? this.placesRefvia1.place.name: "").length > 0? this.placesRefvia1.place.geometry.location.lat(): 0;
            var lng1 = this.f_chkString(this.placesRefvia1.place? this.placesRefvia1.place.name: "").length > 0? this.placesRefvia1.place.geometry.location.lng(): 0;
            var lat2 = this.f_chkString(this.placesRefvia2.place? this.placesRefvia2.place.name: "").length > 0? this.placesRefvia2.place.geometry.location.lat(): 0;
            var lng2 = this.f_chkString(this.placesRefvia2.place? this.placesRefvia2.place.name: "").length > 0? this.placesRefvia2.place.geometry.location.lng(): 0;
            if(lat1 > 0 && lng1 > 0 && lat2 > 0 && lng2 > 0){
                KM = KM + this.CalculateDistance(lat1, lng1,lat2, lng2, "K");
            }
        }
        if(id > 2){
            var lat1 = this.f_chkString(this.placesRefvia2.place? this.placesRefvia2.place.name: "").length > 0? this.placesRefvia2.place.geometry.location.lat(): 0;
            var lng1 = this.f_chkString(this.placesRefvia2.place? this.placesRefvia2.place.name: "").length > 0? this.placesRefvia2.place.geometry.location.lng(): 0;
            var lat2 = this.f_chkString(this.placesRefvia3.place? this.placesRefvia3.place.name: "").length > 0? this.placesRefvia3.place.geometry.location.lat(): 0;
            var lng2 = this.f_chkString(this.placesRefvia3.place? this.placesRefvia3.place.name: "").length > 0? this.placesRefvia3.place.geometry.location.lng(): 0;
            if(lat1 > 0 && lng1 > 0 && lat2 > 0 && lng2 > 0){
                KM = KM + this.CalculateDistance(lat1, lng1,lat2, lng2, "K");
            }
        }
        this.actual_KM = KM;
        console.log("kmm",this.actual_KM)
        this.Routeformgroup.controls['km'].setValue(this.f_ChkNum(KM).toFixed(2));
    }

    route_nm() {
        var name = this.f_chkString(this.placesRef.place? this.placesRef.place.name: "");
        var name1 = this.f_chkString(this.placesRefvia1.place? this.placesRefvia1.place.name: "");
        var name2 = this.f_chkString(this.placesRefvia2.place? this.placesRefvia2.place.name: "");
        var name3 = this.f_chkString(this.placesRefvia3.place? this.placesRefvia3.place.name: "");
        this.route_name = name + (name1.length > 0? ", ": "") + name1 + (name2.length > 0? ", ": "") + name2 + (name3.length > 0? ", ": "") + name3;
        // this.route_name = this.route_name + ", " + data;
        console.log("Route", this.route_name)
    }

    get f() {
        return this.Routeformgroup.controls;
    }

    Routeformgroup = new FormGroup({
        hq: new FormControl(''),
        via1: new FormControl(''),
        via2: new FormControl(''),
        via3: new FormControl(''),
        routeName: new FormControl(''),
        DAType: new FormControl(),
        km: new FormControl(''),
        //DARatePerDay: new FormControl('', [Validators.required]),
        no_Of_Visit_in_a_month: new FormControl(),
        description: new FormControl(),
    });

    ngOnInit() {   
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));      
        this.getRoute();
    }

    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        this.api.hideOverlay();
    }

    onBtnExport() {
        this.api.exportDataAsCsv({ fileName: 'RouteMaster' });
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    }

    CalculateKMDouble(value) {
        if(value == "EX-Station Fare Double Side" || value == "Out-Station Fare Double Side"){
            console.log(this.Routeformgroup.value.km);
             let KMD =this.f_ChkNum(this.actual_KM).toFixed(2);
            this.Routeformgroup.controls['km'].setValue(Number(KMD)*2);
            console.log("KMD",Number(KMD)*2);
        }else{
            
            this.Routeformgroup.controls['km'].setValue(this.f_ChkNum(this.actual_KM).toFixed(2));  
        }
            }

    getRoute() {
        var data = {
            Id: this.token.id
        };
        this.busy = this.apiService.getAllRoute(data)
            .subscribe((res: any) => {
                this.routeData = res.data;
                console.log('getRouteData', res.data);
                setTimeout(function (self) {
                    self.api.sizeColumnsToFit();
                }, 200, this);
            });
    }
    
    ResetRouteForm(){
        this.Routeformgroup.reset();
        this.Routeformgroup.controls['DAType'].setValue('Local');
        // this.Routeformgroup.controls['km'].setValue('10');
    }

    f_ChkNum(p_value) {
        var Num = Number(p_value);
        if(Num){
            return Num;
        }
        return 0;
    }

    f_chkString(p_value) {
        var Val = (p_value ? p_value.toString() : "").trim();
        return Val;
    }

    submitRoute(content) {
        // this.Routeformgroup.value.routeName
        console.log(this.Routeformgroup.value);
        if (this.f_chkString(this.Routeformgroup.value.routeName).length == 0) {
            this.toast.warning('Route Name is Required');
            return false;
        }
        if (this.f_chkString(this.Routeformgroup.value.DAType).length == 0) {
            this.toast.warning('DA Type is Required');
            return false;
        }
        if (this.f_chkString(this.Routeformgroup.value.description).length == 0) {
            this.toast.warning('Description is Required');
            return false;
        }
        if (this.f_ChkNum(this.Routeformgroup.value.no_Of_Visit_in_a_month) == 0) {
            this.toast.warning('No Of visit in a Month is Required');
            return false;
        }
        if (this.f_ChkNum(this.Routeformgroup.value.km) == 0) {
            this.toast.warning('kilometer is Required');
            return false;
        }
        //  var tokenData = JSON.parse(sessionStorage.getItem("currentUser"));
        let status = 0;
        switch (this.Routeformgroup.value.DAType) {
            case "Local":
                status = 1;
                break;
            case "EX-Station Fare Double Side":
                status = 0;
               var KM =this.Routeformgroup.value.km;
                var KMD =this.f_ChkNum(this.actual_KM).toFixed(2);
                if(KM != (Number(KMD)*2)){
                    this.Routeformgroup.controls['km'].setValue(Number(KMD)*2);
                    console.log("KMD",Number(KMD)*2);
                }
                break;
            case "EX-Station Fare Single Side":
                status = 0;
                break;
            case "Out-Station Fare Single Side":
                status = 0;
                break;
            case "Out-Station Fare Double Side":
                status = 0;
                var KM =this.Routeformgroup.value.km;
                var KMD =this.f_ChkNum(this.actual_KM).toFixed(2);
                if(KM != (Number(KMD)*2)){
                    this.Routeformgroup.controls['km'].setValue(Number(KMD)*2);
                    console.log("KMD",Number(KMD)*2);
                }
                break;
            case "DA Not Applicable":
                status = 1;
                break;
            case "MEETING":
                status = 1;
                break;
            case "TRAINING":
                status = 1;
                break;
            default:
                break;
        }
        // console.log(this.routeaddData);
        var data = {
            userId: this.routeaddData.EmpId,
            hq: this.routeaddData.HeadQuarter,
            no_OF_visit_in_a_month: this.Routeformgroup.value.no_Of_Visit_in_a_month,
            via1: this.Routeformgroup.value.via1,
            via2: this.Routeformgroup.value.via2,
            route_name: this.Routeformgroup.value.routeName,
            DA_type: this.Routeformgroup.value.DAType,
            KM: this.Routeformgroup.value.km,
            status: status,
            emp_name: this.routeaddData.EmployeeName
        }

        console.log(data);
        this.busy = this.apiService.saveRouteMaster(data).subscribe((res: any) => {
            this.getRoute();
            this.toast.success(res.msg);
            this.ResetRouteForm();
            this.modal.nativeElement.click();
        });
    }

    CalculateDistance(lat1, lon1, lat2, lon2, unit) {
        if ((lat1 == lat2) && (lon1 == lon2)) {
            return 0;
        } else {
            var radlat1 = Math.PI * lat1 / 180;
            var radlat2 = Math.PI * lat2 / 180;
            var theta = lon1 - lon2;
            var radtheta = Math.PI * theta / 180;
            var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) {
                dist = 1;
            }
            dist = Math.acos(dist);
            dist = dist * 180 / Math.PI;
            dist = dist * 60 * 1.1515;
            if (unit == "K") { dist = dist * 1.609344 }
            if (unit == "N") { dist = dist * 0.8684 }
            return dist;
        }
    }
}